// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"RandomizeAdmin__wrapper__bYupA","labelText":"RandomizeAdmin__labelText__30To6","matchInfo":"RandomizeAdmin__matchInfo__xRaiT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Randomize/RandomizeAdmin.css
// module id = 2852
// module chunks = 0